<ion-header>
  <ion-toolbar mode="md">
    <ion-title size="small">
      <ion-text color="primary">{{ modalTitle }}</ion-text>
    </ion-title>
    <ion-button
      (click)="closeModal()"
      size="small"
      slot="end"
      fill="clear"
      color="dark"
      [attr.aria-label]="closeLabel"
    >
      <ion-icon
        slot="icon-only"
        src="assets/ionicons/close.svg"
        aria-hidden="true"
      ></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="funding-pdf-frame" *ngIf="safePdfUrl">
    <iframe [src]="safePdfUrl" [title]="modalTitle"></iframe>
  </div>
</ion-content>
